import React, { useState } from 'react';
import { X } from 'lucide-react';
import { StageSelector, PriorityBadge } from './CRMSelectors';
import InquiryInfo from './InquiryInfo';
import FollowUpSection from './FollowUpSection';
import InquiryActions from './InquiryActions';
import AIReplyPanel from './AIReplyPanel';
import AttributionPanel from './AttributionPanel';
import NotesSection from './NotesSection';

export default function InquiryDetail({ inquiry, today, onClose, onUpdate, onAddNote, onDeleteNote, onDelete }) {
  const [aiReply, setAiReply] = useState(null);
  const update = (data) => onUpdate(inquiry.id, data);

  return (
    <div className="lg:col-span-2">
      <div className="bg-white rounded-lg border border-saffron-100/50 shadow-card-lift p-6 sticky top-28" data-testid="inquiry-detail">
        <div className="flex items-start justify-between mb-4">
          <div>
            <span className="text-[10px] uppercase tracking-wider text-saffron font-sans font-semibold">#{inquiry.id}</span>
            <h2 className="font-display text-xl font-bold text-earth-dark mt-1" data-testid="inquiry-detail-name">{inquiry.name}</h2>
            <p className="text-sm text-earth/60 font-sans">{inquiry.company}</p>
          </div>
          <button onClick={onClose} className="text-earth/30 hover:text-earth" data-testid="inquiry-detail-close"><X size={18} /></button>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <StageSelector current={inquiry.stage || 'new'} onChange={(stage) => update({ stage })} />
          <PriorityBadge priority={inquiry.priority || ''} onChange={(priority) => update({ priority })} />
        </div>

        <InquiryInfo inquiry={inquiry} />
        <FollowUpSection inquiry={inquiry} today={today} onChange={(follow_up_date) => update({ follow_up_date })} />
        <InquiryActions inquiry={inquiry} onAiReply={setAiReply} onDelete={() => onDelete(inquiry.id)} />
        {aiReply && <AIReplyPanel reply={aiReply} email={inquiry.email} onClose={() => setAiReply(null)} />}
        <AttributionPanel attribution={inquiry.attribution} />
        <NotesSection
          notes={inquiry.notes}
          onAdd={(text) => onAddNote(inquiry.id, text)}
          onDelete={(noteId) => onDeleteNote(inquiry.id, noteId)}
        />
      </div>
    </div>
  );
}
